<template>
  <div class="fultServiceCenter-details">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" content="故障详情" />
    <ml-tip class="scroll-box" :showHeader="false" style="border: 0">
      <el-scrollbar :height="tabberHeight(185)">
        <div class="content-box">
          <el-tabs v-model="activeName" class="demo-tabs">
            <el-tab-pane label="故障详情" name="detail"></el-tab-pane>
            <el-tab-pane label="流程进度" name="process"></el-tab-pane>
            <el-tab-pane label="里程信息" name="pec"></el-tab-pane>
          </el-tabs>
          <div v-if="activeName === 'detail'">
            <ml-form
              ref="faultServiceCenterFormRef"
              labelWidth="100px"
              style="width: 1200px; margin: 20px auto 40px"
              :rules="faultServiceCenterFormRules"
              :model="faultServiceCenterForm"
            >
              <!-- 提示标题 -->
              <!-- <el-divider content-position="left" style="font-weight: bold">故障详情信息</el-divider> -->
              <div class="globalTitle fultServiceCenter-details-globalTitle">
                故障详情
                <el-image
                  class="fultServiceCenter-details-globalTitle-image"
                  v-if="errorOrderStatusImg"
                  :src="errorOrderStatusImg"
                />
              </div>
              <el-row>
                <el-col :span="12">
                  <ml-select
                    prop="companyId"
                    placeholder="请选择阿米巴"
                    :options="unitOptions"
                    label="阿米巴:"
                    keyName="companyId"
                    labelName="companyName"
                    valueName="companyId"
                    v-model="faultServiceCenterForm.companyId"
                    @change="setCompany"
                    disabled
                  />
                </el-col>
                <el-col :span="12">
                  <!-- 所属项目 -->
                  <ml-select
                    prop="projectId"
                    placeholder="请选择所属项目"
                    :options="projectData"
                    label="所属项目:"
                    keyName="projectId"
                    labelName="projectName"
                    valueName="projectId"
                    v-model="faultServiceCenterForm.projectId"
                    disabled
                  />
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <ml-select
                    prop="relatedSite"
                    placeholder="请选择关联站点"
                    :options="siteListData"
                    label="关联站点:"
                    keyName="id"
                    labelName="siteAddr"
                    valueName="id"
                    v-model="faultServiceCenterForm.relatedSite"
                    :filterable="true"
                    :disabled="formDisabled"
                  />
                </el-col>
                <el-col :span="12">
                  <ml-select
                    prop="severity"
                    placeholder="请选择严重程度"
                    :options="severityData"
                    label="严重程度:"
                    labelName="label"
                    valueName="label"
                    v-model="faultServiceCenterForm.severity"
                    :disabled="formDisabled"
                  />
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <ml-input
                    prop="title"
                    label="工单标题:"
                    placeholder="请输入标题"
                    v-model.trim="faultServiceCenterForm.title"
                    :disabled="formDisabled"
                  />
                </el-col>
                <el-col :span="12">
                  <ml-input
                    prop="address"
                    label="故障发生地:"
                    placeholder="请输入地点"
                    v-model.trim="faultServiceCenterForm.address"
                    :disabled="formDisabled"
                  />
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <!-- 故障类型级联选择器：只能选择第一级，子级仅展示 -->
                    <ml-input
                      prop="errorTypeName"
                      label="故障类型:"
                      placeholder="请选择故障类型"
                      v-model.trim="faultServiceCenterForm.errorTypeName"
                      disabled
                    />
                    <!-- <el-cascader
                      v-model="errorType"
                      :options="errorTypeData"
                      :props="{
                        value: 'id',
                        label: 'title',
                        children: 'children',
                        expandTrigger: 'click',
                        checkStrictly: true,
                        emitPath: false
                      }"
                      placeholder="请选择故障类型"
                      clearable
                      style="width: 100%"
                      :disabled="formDisabled"
                    />-->
                </el-col>
                <el-col :span="12">
                  <!-- 流程 -->
                  <ml-input
                    prop="processData.processName"
                    label="流程:"
                    placeholder="请选择流程"
                    v-model.trim="faultServiceCenterForm.processData.processName"
                    disabled
                  />
                </el-col>
              </el-row>

              <ml-input
                prop="errorDesc"
                label="故障描述:"
                :placeholder="formDisabled ? '' : '请输入故障描述'"
                type="textarea"
                :rows="5"
                v-model.trim="faultServiceCenterForm.errorDesc"
                :disabled="formDisabled"
              />
            </ml-form>
            <ml-form
              labelWidth="200px"
              style="width: 1200px; margin: 20px auto 40px"
              :model="faultServiceCenterForm"
            >
              <div class="globalTitle" v-if="faultServiceCenterForm.attachVos.length > 0">附件</div>
              <el-form-item label="附件:" v-if="faultServiceCenterForm.attachVos.length > 0">
                <ml-list
                  fileName="fileName"
                  :showDelete="!formDisabled"
                  :showDown="true"
                  :showPreview="true"
                  :list="faultServiceCenterForm.attachVos"
                />
              </el-form-item>
              <ml-button
                :showCancel="false"
                submitText="上传附件"
                @click-submit="showUploadDia"
                v-if="!formDisabled"
              ></ml-button>
              <div class="globalTitle" v-if="faultServiceCenterForm.signName">签名</div>
              <el-form-item label="签名:" v-if="faultServiceCenterForm.signName">
                <el-image
                  fit="scale-down"
                  style="width: 100px; height: 100px"
                  :src="`${BASEURL}${FILEPREVIEWURL}/${faultServiceCenterForm.signName}`"
                  hide-on-click-modal
                  :preview-src-list="[
                    `${BASEURL}${FILEPREVIEWURL}/${faultServiceCenterForm.signName}`
                  ]"
                />
              </el-form-item>

              <div class="globalTitle" v-if="orderRepairRecordByError.partFlag === 'Y'">
                备品消耗
              </div>
              <ml-form
                v-if="orderRepairRecordByError.partFlag === 'Y'"
                labelWidth="200px"
                disabled
                style="width: 1200px; margin: 20px auto 40px"
                :model="orderRepairRecordByError"
              >
                <el-row>
                  <el-col :span="12">
                    <ml-input
                      prop="partName"
                      placeholder="请输入消耗备品名称"
                      label="消耗备品名称:"
                      v-model="orderRepairRecordByError.partName"
                    />
                  </el-col>
                  <el-col :span="12">
                    <ml-input-number
                      prop="partCount"
                      placeholder="请输入数量"
                      label="数量:"
                      :min="0"
                      v-model="orderRepairRecordByError.partCount"
                    />
                  </el-col>
                </el-row>
              </ml-form>
            </ml-form>
          </div>
          <div v-else-if="activeName === 'process'">
            <div class="globalTitle" v-if="deviceErrorLogsByError.length > 0">流程进度</div>
            <el-form-item v-if="deviceErrorLogsByError.length > 0" style="margin-bottom: 60px">
              <process-schedule-new
                disabled
                v-for="(item, index) in deviceErrorLogsByError"
                :key="item"
                :item="item"
                :state="index === 0"
                type="fault_task"
                @view-form="viewFromHandle"
              />
            </el-form-item>
          </div>
          <div v-else-if="activeName === 'pec'">
            <div class="globalTitle" v-if="deviceErrorLogsByError.length > 0">里程信息</div>
            <el-table :data="pecList" style="width: 100%">
              <el-table-column align="center" label="车牌号" prop="carNumber" min-width="15%" />
              <el-table-column align="center" label="出发地址" prop="startAddr" min-width="15%" />
              <el-table-column align="center" label="出发地图片" prop="companyName" min-width="15%">
                <template #default="scope">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="`${BASEURL}${FILEPREVIEWURL}/${scope.row.startFileList[0].filePath}`"
                    hide-on-click-modal
                    v-if="scope.row.startFileList[0]"
                    :preview-src-list="[
                      `${BASEURL}${FILEPREVIEWURL}/${scope.row.startFileList[0].filePath}`
                    ]"
                  />
                </template>
              </el-table-column>
              <el-table-column align="center" label="出发时间" prop="createTime" min-width="15%" />
              <el-table-column
                align="center"
                label="目的地地址"
                prop="endAddress"
                min-width="15%"
              />
              <el-table-column align="center" label="目的地图片" prop="companyName" min-width="15%">
                <template #default="scope">
                  <el-image
                    style="width: 60px; height: 60px"
                    :src="`${BASEURL}${FILEPREVIEWURL}/${scope.row.endFileList[0].filePath}`"
                    hide-on-click-modal
                    v-if="scope.row.endFileList[0]"
                    :preview-src-list="[
                      `${BASEURL}${FILEPREVIEWURL}/${scope.row.endFileList[0].filePath}`
                    ]"
                  />
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="到达时间"
                prop="endCreateTime"
                min-width="15%"
              />
              <el-table-column align="center" label="乘车人员" prop="endCreateTime" min-width="15%">
                <template #default="scope">
                  <span
                    v-for="item in scope.row.byCarUserVos"
                    :key="item.userId"
                    style="margin-right: 8px"
                    >{{ item.userName }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态" prop="companyName" min-width="15%">
                <template #default="scope">
                  <span>{{ scope.row.recordType === 'START' ? '进行中' : '已完成' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="里程数(km)"
                prop="actualMileage"
                min-width="15%"
              ></el-table-column>
            </el-table>
          </div>
          <!-- 表单 -->
        </div>
      </el-scrollbar>
    </ml-tip>

    <!-- 处理故障按钮组 -->
    <div class="btn-box">
      <el-button
        v-for="item in customButtons"
        :key="item.value"
        size="medium"
        type="primary"
        @click="clickReportOrder(item)"
      >
        {{ item.name }}
      </el-button>
      <el-button size="medium" icon="el-icon-circle-close" @click="clickCancelFultServiceCenter">
        返回上一页
      </el-button>
      <el-button size="medium" icon="el-icon-download" type="primary" @click="clickDownloadExcel">
        导出
      </el-button>
    </div>
    <!-- 上传附件-资源管理器 -->
    <c-upload-dlg
      v-if="uploadConfig.length > 0"
      ref="cUploadDlgRef"
      v-model="uploadData"
      :config="uploadConfig"
    />
    <!-- 派单 -->
    <distribute-dialog
      v-if="showDistributeDialog"
      :conf="processCof"
      :btnCode="btnCode"
      :btnName="btnName"
      ref="distributeRef"
      :multiple="multipleSelection"
      @close="closeDistributedDialog"
      @success="successDistributedDialog"
    ></distribute-dialog>
    <!-- 办结 -->
    <completed-dialog
      v-if="showCompletedDialog"
      ref="completedRef"
      :conf="processCof"
      :btnCode="btnCode"
      :btnName="btnName"
      :type="completedType"
      :sourData="sourData"
      :projectId="faultServiceCenterForm.projectId"
      busType="device_error"
      @close="closeCompletedDialog"
      @success="successCompletedDialog"
    ></completed-dialog>
    <!-- 提交报告 -->
    <submit-dialog
      v-if="showSubmitDialog"
      ref="submitRef"
      :conf="processCof"
      :btnCode="btnCode"
      :btnName="btnName"
      :type="submitType"
      :companyId="faultServiceCenterForm.companyId"
      :projectId="faultServiceCenterForm.projectId"
      :sourData="sourData"
      :errorInfo="faultServiceCenterForm"
      :errorId="faultServiceCenterForm.errorId"
      @close="closeSubmitDialog"
      @success="successSubmitDialog"
    ></submit-dialog>
  </div>
</template>

<script>
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { getTabberData, tabberHeight, searchParams, downloadFile } from '@/utils'
import ProcessScheduleNew from '@components/processScheduleNew.vue'
import { BASEURL, FILEPREVIEWURL } from '@API'
import { exportDeviceErrorById } from '@/API/previewApi'

import distributeDialog from '@/components/processDialog/distributeDialog'
import completedDialog from '@/components/processDialog/completedDialog'
import submitDialog from '@/components/processDialog/submitDialog'

// 待审核
import isAuditImg from '../../assets/image/is-audit.png'
// 待处理
import isDealImg from '../../assets/image/is-deal.png'
// 已办结
import completeImg from '../../assets/image/complete.png'
// 已完成
import completeIng from '../../assets/image/completeIng.png'
// 已处理
import deal from '../../assets/image/deal.png'
// 处理中
import dealIng from '../../assets/image/deal-ing.png'
// 未办结
import noComplete from '../../assets/image/no-complete.png'

import { useProcessHandler } from '@/utils/useProcessHandler'

export default {
  name: 'FultServiceCenterDetails',
  components: {
    ProcessScheduleNew,
    distributeDialog,
    completedDialog,
    submitDialog
  },
  setup() {
    const { commit, getters, dispatch } = useStore()
    const router = useRouter()
    const route = useRoute()
    const { errorId } = route.query
    // 待处理 （-1 已退回 0 已上报 ）处理中  1 已指派 2 待审核 已处理  3 已办结
    const errorStatus = ref('0')
    const isBusinessDepartment = computed(() => getters.isBusinessDepartment)
    const toKen = computed(() => getters.getToken)
    /* 开始 表单 **********************************/
    // 详情数据
    const faultServiceCenterFormRef = ref()
    const errorType = ref([])
    // 表单配置
    // const faultServiceCenterFormParams = ref()
    const faultServiceCenterForm = reactive({
      address: '',
      attachVos: [],
      companyId: '',
      createById: '',
      createTime: '',
      deviceId: '',
      deviceInfo: {},
      deviceName: '',
      deviceType: '',
      errorDesc: '',
      errorId: '',
      errorStatus: '',
      evaluateStatus: '',
      eventTime: '',
      historyData: '',
      latitude: '',
      longitude: '',
      processData: {
        businessId: '',
        definitionKey: '',
        definitionId: '',
        procInsId: '',
        businessType: ''
      },
      projectId: '',
      propertyType: '',
      remark: '',
      reportType: '',
      reportUser: '',
      severity: '',
      signName: '',
      state: '',
      submitTime: '',
      title: '',
      updateTime: '',
      userType: '',
      errorType: '',
      errorTypeName: '',
      province: '',
      relatedSite: '',
      firstUnit: '',
      secondUnit: '',
      city: '',
      area: '',
      isAuditPass: '',
      isAuditRefuse: '',
      isOrderBack: '',
      isOrderEvaluate: '',
      isRepeatSubmit: '',
      isReportBack: '',
      isReportComplete: '',
      isReportOrder: '',
      isReportSubmit: '',
      showStatusText: ''
    })
    // 表单校验
    const faultServiceCenterFormRules = {
      companyId: [{ required: true, message: '请选择阿米巴 ', trigger: 'blur' }],
      projectId: [{ required: true, message: '请选择所属项目', trigger: 'blur' }],
      propertyType: [{ required: true, message: '请输入资产类别', trigger: 'blur' }],
      deviceType: [{ required: true, message: '请输入设备类型', trigger: 'blur' }],
      deviceId: [{ required: true, message: '请选择设备', trigger: 'blur' }],
      title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
      severity: [{ required: true, message: '请选择严重程度', trigger: 'blur' }],
      address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
      processData: {
        definitionId: [{ required: true, message: '请选择流程', trigger: 'blur' }]
      }
    }

    const activeName = ref('detail')

    // 站点列表数据
    const siteListData = ref([])
    // 故障类型字典数据
    const errorTypeData = ref([])

    // 获取站点列表
    const getSiteListData = async () => {
      try {
        // 根据接口文档，站点列表查询只需要 siteAddr 参数
        const siteParams = {
          siteAddr: '' // 空字符串表示查询所有站点
        }
        const data = await dispatch('fetchGetPcsSiteList', siteParams)
        if (data && data.code === 200) {
          siteListData.value = data.data || []
        }
      } catch (error) {
        console.error('获取站点列表失败:', error)
      }
    }

    // 处理故障类型数据：子级禁用 + 清理空children
    const processErrorTypeData = data => {
      if (!data || !Array.isArray(data)) return []
      return data.map(item => {
        const newItem = { ...item }
        // 如果有子级，处理子级
        if (newItem.children && newItem.children.length > 0) {
          // 子级全部禁用（不可选择，仅展示）
          newItem.leaf = false
          newItem.children = newItem.children.map(child => ({
            ...child,
            disabled: true,
            leaf: child.children && child.children.length > 0 ? false : true
          }))
        } else {
          newItem.leaf = true
          // 没有子级，删除 children 属性，避免展开空面板
          delete newItem.children
        }
        return newItem
      })
    }

    // 获取故障类型字典数据
    const getErrorTypeData = async () => {
      try {
        const data = await dispatch('fetchGetDictTreeByType', { dictType: 'error_type' })
        if (data && data.code === 200) {
          errorTypeData.value = processErrorTypeData(data.data) || []
        }
      } catch (error) {
        console.error('获取故障类型字典失败:', error)
      }
    }

    const errorOrderStatusImg = ref()
    watch(
      () => faultServiceCenterForm.showStatusText,
      newvalue => {
        if (newvalue) {
          switch (newvalue) {
            case '待审核':
              errorOrderStatusImg.value = isAuditImg
              break
            case '已办结':
              errorOrderStatusImg.value = completeImg
              break
            case '已完成':
              errorOrderStatusImg.value = completeIng
              break
            case '已处理':
              errorOrderStatusImg.value = deal
              break
            case '处理中':
              errorOrderStatusImg.value = dealIng
              break
            case '未办结':
              errorOrderStatusImg.value = noComplete
              break

            default:
              errorOrderStatusImg.value = isDealImg
              break
          }
        }
      }
    )

    // 备件消耗
    const orderRepairRecordByError = reactive({
      partFlag: '',
      partName: '',
      partCount: 0
    })

    // 类型下拉列表
    const typeData = ref([{ label: '故障' }, { label: '缺陷' }])
    // 严重程度下拉列表
    const severityData = ref([
      { label: '轻微' },
      { label: '一般' },
      { label: '严重' },
      { label: '灾难' }
    ])
    // 单位名下拉列表
    const unitOptions = ref([])
    // 所属项目下拉列表
    const projectData = ref([])
    // 工单流程列表
    const processOption = ref([])
    // 流程列表
    const processData = ref([])

    // 设备下拉列表
    const equipmentManageata = ref([])
    // 处理所属项目
    const getProjectData = async companyId => {
      const projectParams = {}
      if (isBusinessDepartment.value) {
        projectParams.companyId = companyId
      }
      const { data } = await getTabberData(dispatch, 'fetchGetProjectsByCompany', projectParams)
      projectData.value = data || []
    }
    const setCompany = () => {
      faultServiceCenterForm.projectId = ''
      faultServiceCenterForm.relatedSite = ''
    }
    watch(
      () => faultServiceCenterForm.projectId,
      () => {
        getSiteListData()
        getProcessData()
      }
    )
    watch(
      () => faultServiceCenterForm.companyId,
      newvalue => {
        getProjectData(newvalue)
        getSiteListData()
      }
    )
    const getProcessData = () => {
      let params = {
        companyId: '',
        projectId: faultServiceCenterForm.projectId,
        businessType: 'device_error',
        pageIndex: 1,
        pageSize: 500
      }
      dispatch('fetchProjectProcessPage', params).then(res => {
        if (res.code === 200) {
          processData.value = res.data.records
        }
      })
    }
    // 获取单个故障信息
    const getFaultServiceCenterDetails = async () => {
      // 查看故障详情
      await dispatch('fetchDeviceErrorRecordById', errorId).then(data => {
        if (data && data.code === 200 && data.data) {
          errorStatus.value = data.data.errorStatus
          // 绑定阿米巴和项目ID
          const { firstUnit, secondUnit } = data.data.deviceInfo || {}

          Object.keys(faultServiceCenterForm).map(item => {
            if (['attachVos'].includes(item)) {
              faultServiceCenterForm[item] = data.data[item] || []
            } else if (['firstUnit'].includes(item)) {
              faultServiceCenterForm[item] = firstUnit
            } else if (['secondUnit'].includes(item)) {
              faultServiceCenterForm[item] = secondUnit
            } else {
              faultServiceCenterForm[item] = data.data[item]
            }
          })
          errorType.value = faultServiceCenterForm.errorType
            ? [faultServiceCenterForm.errorType]
            : []
          if (faultServiceCenterForm.errorType) {
            const item = errorTypeData.value.find(
              option => option.id === faultServiceCenterForm.errorType
            )
            faultServiceCenterForm.errorTypeName = item ? item.title : ''
          } else {
            faultServiceCenterForm.errorTypeName = ''
          }
        }
      })
    }
    const clickCancelFultServiceCenter = () => {
      router.go(-1)
    }
    // 导出 Excel
    const clickDownloadExcel = () => {
      exportDeviceErrorById({ id: errorId })
        .then(res => {
          const disposition = res.headers && res.headers['content-disposition']
          let fileName = `${faultServiceCenterForm.title || '故障详情'}.docx`
          if (disposition) {
            const match = disposition.match(/filename=(.+)/)
            if (match) {
              fileName = decodeURIComponent(match[1])
            }
          }
          downloadFile(res.data, fileName)
        })
        .catch(() => {})
    }

    /** 流程处理 开始 2024-09-14 ***********************************/
    // 提交表单
    const clickSubmitFultServiceCenter = () => {
      faultServiceCenterFormRef.value.CustomFormRef.validate()
        .then(() => {
          const faultServiceCenterParams = searchParams(faultServiceCenterForm, [
            'firstUnit',
            'secondUnit'
          ])
          faultServiceCenterParams.deviceInfo = {}
          const { firstUnit, secondUnit } = faultServiceCenterForm
          if (firstUnit) {
            faultServiceCenterParams.deviceInfo.firstUnit = firstUnit
          }
          if (secondUnit) {
            faultServiceCenterParams.deviceInfo.secondUnit = secondUnit
          }
          dispatch('fetchNewAddDeviceErrorRecord', faultServiceCenterParams).then(data => {
            if (data && data.code === 200) {
              commit('setError', {
                status: true,
                title: data.message,
                message: '正在获取新的数据...',
                type: 'success'
              })
              updateInfoHandle()
            }
          })
        })
        .catch(() => {})
    }

    const updateInfoHandle = async () => {
      await getErrorTypeData()
      await getFaultServiceCenterDetails()
      await getProcessConf(errorId)
      await getDeviceErrorLogsByError(errorId)
    }
    const {
      btnCode,
      btnName,
      processCof,
      customButtons,
      formDisabled,
      deviceErrorLogsByError,
      showDistributeDialog,
      distributeRef,
      completedType,
      showCompletedDialog,
      completedRef,
      sourData,
      showSubmitDialog,
      submitRef,
      submitType,
      getProcessConf,
      getDeviceErrorLogsByError,
      clickReportOrder,
      successDistributedDialog,
      closeDistributedDialog,
      successCompletedDialog,
      closeCompletedDialog,
      successSubmitDialog,
      closeSubmitDialog,
      viewFromHandle,
      multipleSelection
    } = useProcessHandler(dispatch, updateInfoHandle, clickSubmitFultServiceCenter)

    /** 流程处理 结束***********************************/

    /* 2021-12-15 新版上传文件管理器 wml ******************/
    // 上传资源管理器属性
    const cUploadDlgRef = ref()
    const uploadData = ref([])
    const uploadConfig = ref([])

    watch(
      () => uploadData.value,
      newvalue => {
        faultServiceCenterForm.attachVos = [...faultServiceCenterForm.attachVos, ...newvalue]
      }
    )
    // 打开对话框
    const showUploadDia = () => {
      const { companyId, projectId } = faultServiceCenterForm
      uploadData.value = []
      const nArr = []
      if (companyId) {
        nArr.push(companyId)
        if (projectId) {
          nArr.push(projectId)
        }
      }
      uploadConfig.value = [...nArr]
      nextTick(() => {
        cUploadDlgRef.value.uploadDialogRef.showDialog = true
      })
    }

    let pecList = ref([])

    const getPecListHandle = () => {
      dispatch('fetchListByErrorIdPcs', { errorId: errorId }).then(res => {
        if (res.code === 200) {
          pecList.value = res.data
          let recordList = res.data
          pecList.value = recordList.map(d => {
            const endItem = d.recordList.find(k => k.recordType === 'END')
            const startItem = d.recordList.find(k => k.recordType === 'START')
            if (endItem) {
              d.recordType = 'END'
              d.endAddress = endItem.addr
              d.actualMileage = endItem.actualMileage
              d.endCreateTime = endItem.createTime
            } else {
              d.recordType = 'START'
            }
            d.createTime = (startItem && startItem.createTime) || ''
            d.startFileList = (startItem && startItem.fileList) || []
            d.endFileList = (endItem && endItem.fileList) || []
            return d
          })
          console.log('pecList', pecList.value)
        }
      })
    }
    /* 2021-12-15 新版上传文件管理器 wml ******************/

    onMounted(async () => {
      // 获取单位名
      const { data } = await getTabberData(dispatch, 'fetchGetCompanyInfos', {
        noCompanyCode: 'business_department'
      })
      unitOptions.value = data || []
      // 获取单个故障信息
      updateInfoHandle()
      getPecListHandle()
    })
    return {
      clickDownloadExcel,
      faultServiceCenterForm,
      unitOptions,
      projectData,
      clickCancelFultServiceCenter,
      tabberHeight,
      setCompany,
      equipmentManageata,
      typeData,
      severityData,
      toKen,
      errorStatus,
      orderRepairRecordByError,
      deviceErrorLogsByError,
      processOption,
      FILEPREVIEWURL,
      BASEURL,
      errorOrderStatusImg,
      processData,
      customButtons,
      showDistributeDialog,
      distributeRef,
      getDeviceErrorLogsByError,
      clickReportOrder,
      showCompletedDialog,
      completedRef,
      processCof,
      btnCode,
      btnName,
      closeCompletedDialog,
      successCompletedDialog,
      successDistributedDialog,
      closeDistributedDialog,
      showSubmitDialog,
      submitRef,
      successSubmitDialog,
      closeSubmitDialog,
      viewFromHandle,
      submitType,
      completedType,
      sourData,
      formDisabled,
      uploadData,
      showUploadDia,
      cUploadDlgRef,
      uploadConfig,
      clickSubmitFultServiceCenter,
      faultServiceCenterFormRef,
      faultServiceCenterFormRules,
      activeName,
      getPecListHandle,
      pecList,
      multipleSelection,
      siteListData,
      getSiteListData,
      errorType
    }
  }
}
</script>

<style lang="scss">
.fultServiceCenter-details {
  position: relative;
  &-globalTitle {
    position: relative;
    z-index: 1;
    &-image {
      position: absolute;
      width: 100px;
      top: -50px;
      left: 150px;
    }
  }
}

.name-tag-box {
  border: 1px solid $--border-color-base;
  border-radius: 4px;
  padding: 0 5px;
  min-height: 40px;
  max-height: 110px;
  overflow-x: hidden;
  .el-tag {
    margin-right: 5px;
  }
}
.assignedPeople-select {
  .el-input__inner {
    width: 150px;
  }
}

.assignedPeople-table-box {
  border-top: 1px solid $--border-color-lighter;
  padding-top: 10px;
}
.btn-box {
  display: flex;
  align-items: center;
  padding-left: 450px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px;
  background: #fff;
  border-top: 1px dashed #ebeef5;
}
.content-box {
  padding-bottom: 60px;
  box-sizing: border-box;
  width: 1200px;
  margin: 0 auto;
}
</style>
